exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".freight-table[data-v-d1fe9f10]{min-height:16rem;max-height:24rem}i.anticon[data-v-d1fe9f10]{height:1rem}", ""]);

// exports
